import React, { PureComponent } from 'react';

import { connect } from 'react-redux';

import IconButton from 'material-ui/IconButton';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from 'material-ui/Tooltip';

import ExerciseVideoThumbnail from './ExerciseVideoThumbnail';
import ExerciseTable from './ExerciseTable';

import * as Utils from '../../../../lib/designerUtils';
import * as DesignerState from '../../../../state/reducer/designer/designer';
import Console from '../../../../lib/debug';

export class ExerciseClass extends PureComponent {
    breakLink = () => {
        let session = this.props.session;
        let block = this.props.block;
        let exercise = this.props.exercise;
        DesignerState.unlink(session, block, exercise);
    };

    makeLink = () => {
        let session = this.props.session;
        let block = this.props.block;
        let nextBlock = this.props.nextBlock;
        DesignerState.link(session, block, nextBlock);
    };

    moveExercise(direction) {
        let dispatch = this.props.dispatch;
        let block = this.props.block;
        let exercise = this.props.exercise;
        DesignerState.moveExercise(dispatch, block, exercise, direction);
    }

    moveBlock(direction) {
        let session = this.props.session;
        let dispatch = this.props.dispatch;
        let block = this.props.block;
        DesignerState.moveBlock(dispatch, session, block, direction);
    }

    toggleDeleteExerciseDialog() {
        let dispatch = this.props.dispatch;
        let block = this.props.block;
        let exercise = this.props.exercise;
        DesignerState.toggleDeleteExerciseDialog(
            dispatch,
            exercise,
            block,
            true,
            'Exercise'
        );
    }

    updateInstructions(event) {
        let dispatch = this.props.dispatch;
        let exercise = this.props.exercise;

        DesignerState.updateExerciseValue(
            dispatch,
            exercise,
            'instruction',
            event.target.value
        );
    }

    render() {
        Console.render('designer.Exercise');

        let exercise = this.props.exercise || this.props.exerciseKey || {};
        let block = this.props.block;
        let nextBlock = this.props.nextBlock;
        let session = this.props.session;
        let position = this.props.position;
        let dispatch = this.props.dispatch;
        let thumbCollection = this.props.thumbLibrary;
        let exercisePreview = null;
        let exerciseCount = block.exerciseKeys.length;
        let hasMultiple = exerciseCount > 1;
        let exerciseIndex = block.exerciseKeys.indexOf(exercise.key);
        let isLast = exerciseIndex + 1 === exerciseCount;
        let supersetLine = null;
        if (hasMultiple && !isLast) {
            supersetLine = (
                <div className="superset-link" onClick={this.breakLink}>
                    <div className="line">
                        <i className="mdi mdi-link-variant" />
                    </div>
                </div>
            );
        } else if (
            nextBlock &&
            nextBlock.plain_text !== 1 &&
            nextBlock.exerciseKeys.length > 0 &&
            block.exerciseKeys.length > 0
        ) {
            supersetLine = (
                <Tooltip title="Create superset">
                    <div
                        className="block-superset-link"
                        onClick={this.makeLink}
                    >
                        <div className="line">
                            <i className="mdi mdi-link-variant" />
                        </div>
                    </div>
                </Tooltip>
            );
        }

        let blockPosition = session.setKeys.indexOf(block.key);
        let numBlocks = session.setKeys.length;
        let numExercises = block.exerciseKeys.length;
        let exercisePosition = block.exerciseKeys.indexOf(exercise.key);
        let buttons = [];
        if (
            Utils.hasMultiple(numExercises) &&
            !Utils.isFirst(exercisePosition)
        ) {
            buttons.push(
                <div className="move-button previous" key="b1">
                    <Tooltip title="Move Exercise Up">
                        <IconButton
                            className="option-button"
                            onClick={() => this.moveExercise(-1)}
                        >
                            <ExpandLessIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        } else if (
            !Utils.isFirst(blockPosition, numBlocks) &&
            Utils.hasMultiple(numExercises)
        ) {
            buttons.push(
                <div className="move-button previous" key="b1">
                    <Tooltip title="Move Superset Up">
                        <IconButton
                            className="option-button"
                            onClick={() => this.moveBlock(-1)}
                        >
                            <ExpandLessIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        } else if (
            Utils.isFirst(blockPosition, numBlocks) &&
            Utils.hasMultiple(numExercises)
        ) {
            buttons.push(<div className="move-button previous" key="b1" />);
        }
        if (Utils.hasMultiple(numExercises)) {
            buttons.push(
                <div className="move-button delete has-multiple" key="b2">
                    <Tooltip title="Delete Exercise">
                        <IconButton
                            className="option-button"
                            onClick={this.toggleDeleteExerciseDialog.bind(this)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        }
        if (
            !Utils.isLast(exercisePosition, numExercises) &&
            Utils.hasMultiple(numExercises)
        ) {
            buttons.push(
                <div className="move-button next" key="b3">
                    <Tooltip title="Move Exercise Down">
                        <IconButton
                            className="option-button"
                            onClick={() => this.moveExercise(1)}
                        >
                            <ExpandMoreIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        } else if (
            !Utils.isLast(blockPosition, numBlocks) &&
            Utils.hasMultiple(numExercises)
        ) {
            buttons.push(
                <div className="move-button next" key="b3">
                    <Tooltip title="Move Superset Down">
                        <IconButton
                            className="option-button"
                            onClick={() => this.moveBlock(1)}
                        >
                            <ExpandMoreIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        }

        let moveButtons = <div className="move-buttons">{buttons}</div>;
        if (thumbCollection && thumbCollection.videoThumbnail) {
            exercise.video_thumbnail = thumbCollection.videoThumbnail;
        }

        if (block.plain_text !== 1) {
            let className = 'exercise';
            exercisePreview = (
                <div
                    className={className}
                    ref={node => {
                        this.node = node;
                    }}
                >
                    {moveButtons}
                    {supersetLine}
                    <ExerciseTable
                        key={exercise.id}
                        exercise={exercise}
                        isLast={this.props.isLast}
                        horizontal={this.props.horizontal}
                        block={block}
                        dispatch={dispatch}
                        blockPosition={blockPosition}
                        position={position}
                        parent={this.node}
                        session={session}
                    />
                </div>
            );
        } else {
            exercisePreview = (
                <ExerciseVideoThumbnail
                    exercise={exercise}
                    isLast={this.props.isLast}
                    horizontal={this.props.horizontal}
                    block={block}
                    dispatch={dispatch}
                    position={position}
                />
            );
        }
        return exercisePreview;
    }
}

const mapStateToExerciseProps = (state, ownProps) => {
    let ex = state.calendar.exerciseTree[ownProps.exerciseKey];
    if (ex && state.uiTree.exercises && state.uiTree.exercises[ex.key]) {
        ex.video_thumbnail = state.uiTree.exercises[ex.key].videoThumbnail;
    }
    return {
        exercise: ex,
        thumbLibrary: ex ? state.uiTree.exercises[ex.key] : null,
        ...ownProps
    };
};

export default connect(mapStateToExerciseProps)(ExerciseClass);
